import { List } from 'immutable';
import { useMemo } from 'react';
// @ts-expect-error untyped import
import { useFetchDatasetById } from 'reporting-snowflake/dataset/dataset-meta';
import { DataSourceTypes } from 'reporting-snowflake/relational/schema/data-source';
import { processDatasetMeasures, processDatasetDerivedFields } from 'reporting-snowflake/relational/utils/dataset-derived-fields-utils';
import { processDatasetPropertyFields } from 'reporting-snowflake/relational/utils/dataset-property-field-utils';
import { createDatasetPropertyGroup } from '../../lib/relational-report-utils/dataset-property-utils';
const processDatasetFields = (tableDescription, dataset, loading) => {
  const propertyFields = processDatasetPropertyFields({
    tableDescription,
    dataset,
    loading
  });
  const derivedFields = processDatasetDerivedFields({
    tableDescription,
    dataset,
    loading,
    activeTab: 'MAIN'
  });
  const datasetMeasures = processDatasetMeasures({
    tableDescription,
    dataset,
    loading
  });
  return {
    propertyFields,
    derivedFields,
    datasetMeasures
  };
};
const emptyReturn = {
  allDatasetProperties: [],
  allDatasetFields: null
};
export const useDatasetProperties = ({
  relationalReport
}) => {
  const tableDescription = relationalReport.table;
  const {
    loading,
    data: dataset
  } = useFetchDatasetById(tableDescription.datasetId, true, tableDescription.type === DataSourceTypes.HUBSPOT_GLOBAL_DATASET);
  return useMemo(() => {
    if (!loading && !dataset) {
      return Object.assign({
        isDatasetPropertiesLoading: false
      }, emptyReturn);
    }
    const processedDatasetFields = processDatasetFields(tableDescription, dataset, loading);
    if (processedDatasetFields.propertyFields.isLoading || processedDatasetFields.derivedFields.isLoading || processedDatasetFields.datasetMeasures.isLoading) {
      return Object.assign({
        isDatasetPropertiesLoading: true
      }, emptyReturn);
    }
    const allDatasetProperties = [];
    Object.entries(processedDatasetFields).forEach(([__, field]) => {
      const itemsList = Object.values(field).find(val => val instanceof List);
      const group = createDatasetPropertyGroup({
        items: itemsList,
        heading: field.heading
      });
      if (group) {
        allDatasetProperties.push(group);
      }
    });
    return {
      isDatasetPropertiesLoading: false,
      allDatasetProperties,
      allDatasetFields: processedDatasetFields
    };
  }, [tableDescription, dataset, loading]);
};